<template>
  <div>
  <div class="control">
        <div
          style="width: auto; height: 10px; border-bottom: 2px dashed #1e88ff"
        ></div>
        <div class="control2">
          <img src="../images/flow/编组43备份.png" /><span class="fontcss1">身份验证</span>
        </div>
        <div
          style="width: 20%; height: 10px; border-bottom: 2px dashed #1e88ff"
        ></div>
        <div class="control2" style="color: #1e88ff">
          <img src="../images/flow/编组 89.png" /><span class="fontcss">风险测评</span>
        </div>
        <div style="width: 20%; height: 10px; border-bottom: 2px dashed #999999"></div>
        <div class="control2">
          <img src="../images/flow/编组6备份6.png" /><span class="fontcss2">电子签名</span>
        </div>
        <div style="width: auto; height: 10px; border-bottom: 2px dashed"></div>
      </div>

    
    <div>
      <div class="catalogue">
        <!-- <span class="catalogueback">fanhui-2复制</span> -->
         <div class="catalogue3" id="catalogue3" @click="returnback">	&lt;返回</div>
         <div class="catalogue2" id="catalogue1" @click="contract">身份认证</div>
        <!--<div class="catalogue1" id="catalogue2" @click="prospectus">还款计划</div> -->
      </div>
    </div>
      <div class="control3">
      <div class="control4" >
        <img src="../images/flow/编组 12.png" />
      </div>
      <div class="fontcss4">客户未进行风险测评或风险测评已过期</div>
      <div class="control4"></div>
      <div class="text1">
          点击下方按钮开始风险测评
           <div class="bnt1" @click="identification">开始风险测评</div> 
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "flow",
  data() {
    return {
      judge: true,
      bank: "中国工商银行股份有限公司",
      name: "李晓伟",
    };
  },
  methods:{
      contract(){
        return;
         this.judge=true
         this.switchover()
         
      },
      prospectus (){
          this.judge=false
          this.switchover()
      },
      switchover (){
          let a = document.getElementById("catalogue1")    
          let b = document.getElementById("catalogue2")
          if(this.judge){
              b.style.fontWeight="500"
              a.style.fontWeight="bold"
          }else{
              a.style.fontWeight="500"
              b.style.fontWeight="bold"
          }
      },
      returnback(){
        // alert("调用返回");
         this.$router.push({path:'/flow3'})
        return;
      },
      identification(){
        if(true){
            this.$router.push({path:'/flow5'})
        }
      }
      
  },


};
</script>

<style  scoped>
* {
  margin: 0;
}
.bnt {
  width: 300px;
  height: 5rem;
  font-size: 2rem;
  /* font-weight: bold; */
}
.control {
  width: 300px;
  height: 5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.control2 {
  font-size: 0.4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.control4{
  font-size: 0.4rem;
  height: 150px;
  margin: 100 0 0 100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.content {
  width: 300px;
  height: 30rem;
  display: flex;
  /* justify-content: center; */
  overflow-y:auto;
  align-items: center;
  flex-direction: column;
}
.content1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
.catalogue{
  width: 293px;
  height: 36px;
  background: #f3f3f3;
  border-radius: 5px 5px 0px 0px;
}
.catalogueback{
  width: 6px;
  height: 15px;
  background: #999999;
}
.catalogue1{
    width: 15%;
    /* margin-top: 3px; */
    height: 36px;
    background:#F3F3F3;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
}   
.catalogue2{
  width: 280px;
  height: 36px;
  margin-top: -25px;
  font-size: 14px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #09254c;
  line-height: 20px;
  letter-spacing: 0px;
}
.catalogue3{
    width: 20%;
    height: 36px;
    background:#F3F3F3;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
}  
.text1{
  font-size: 12px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
   width: 300px;
   display: flex;
   flex-direction: column;
   justify-content: space-around;
   align-items: center;
   /* height: 10rem; */
   color: #333;
}

.bnt1{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    color: #fff;
    background: #3F96FC;
    width: 15rem;
    height: 3rem;
}
.fontcss{
  color: #3F96FC;
}
.control3{
  width: 76%;
  height: 20rem;
}
.fontcss4{
  margin-left: 18px;
  font-size: 13;
}
.fontcss{
  width: 53px;
  height: 12px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  color: #1e88ff;
  line-height: 18px;
}
.fontcss1{
  width: 60px;
  height: 12px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  color: #333333;
  line-height: 18px;
}
.fontcss2{
  width: 60px;
  height: 12px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  color: #999999;
  line-height: 18px;
}
</style>